import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PmsCaseNumLookupComponent } from './pms-case-num-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PmsCaseNumLookupComponent],
  exports: [PmsCaseNumLookupComponent],
})
export class PmsCaseNumLookupModule { }
